<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('certificates.name')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="input-1"
                    v-model="newItem.name"
                    :state="errors.length > 0 ? false : null"
                    type="text"
                    :placeholder="$t('certificates.name')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- .num_of_study_hours --> </b-col
            ><b-col lg="6">
              <b-form-group
                id="input-group-2"
                :label="$t('certificates.certificate_category')"
                label-for="input-2"
              >
                <div class="demo-inline-spacing">
                  <b-form-radio
                    v-model="Selected"
                    name="program_type"
                    value="مقرأة الكترونية"
                    class="custom-control-primary"
                  >
                    {{ $t("certificates.quran_program") }}
                  </b-form-radio>
                  <b-form-radio
                    v-model="Selected"
                    name="program_type"
                    value="برنامج تعليمي"
                    class="custom-control-primary"
                  >
                    {{ $t("certificates.edu_program") }}
                  </b-form-radio>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <editor :new-item="newItem" ref="editor" />
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
              >
            </b-col>
            <b-col lg="6">
              <b-button block @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";

import { required } from "@validations";
import Controller from "../../../../Controllers/CertificationsController";
import config from "../../../../config/config";
import Editor from "../Editor.vue";

const controller = new Controller();
export default {
  name: "CountriesForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    Editor,
  },
  props: ["newItem"],
  data() {
    return {
      file: {},
      
    };
  },
  methods: {
    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
     
    async submit() {
      let data = this.$refs.editor.getData();
      this.newItem.layout_type = 1;
      if (data.type == "horizontal") this.newItem.layout_type = 2;
      this.newItem.background_img = data.image;
      this.newItem.meta_data = data.text;
      controller.From(this.newItem, "FormData");
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },
  },
};
</script>
